// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"631":"a72013a2","729":"64eb58c3"}[chunkId] + ".chunk.js";
};